module.exports = __webpack_public_path__ + "img/45_20.9a26576f.png";